import Link from 'next/link';

export default function Logo({ light = false }: { light?: boolean }) {
  return (
    <Link href="/" className="group flex items-center gap-2.5" aria-label="이든 영어학원 홈">
      <span
        className={`relative flex h-10 w-10 items-center justify-center rounded-2xl rounded-bl-md font-serif font-extrabold text-xl transition-transform group-hover:-translate-y-0.5 ${
          light ? 'bg-white text-forest' : 'bg-forest text-white'
        }`}
      >
        e
        <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-white bg-sun" />
      </span>
      <span className="leading-none">
        <span className={`block font-serif font-extrabold text-[22px] tracking-tight ${light ? 'text-white' : 'text-ink'}`}>
          Eden
        </span>
        <span className={`mt-0.5 block text-[11px] font-semibold tracking-[0.08em] ${light ? 'text-white/60' : 'text-muted'}`}>
          이든 영어학원
        </span>
      </span>
    </Link>
  );
}
